var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 45,
    viewBox: "0 0 31 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 42V3",
    stroke: "#BEDFFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0647 4H4C3.44772 4 3 4.44772 3 5V20.2558C3 20.8081 3.44772 21.2558 4 21.2558H29.0647C30.0191 21.2558 30.4311 20.0464 29.6752 19.4638L21.8345 13.4199C21.3152 13.0196 21.3152 12.2362 21.8345 11.8359L26.4035 8.31395L29.6752 5.79201C30.4311 5.20938 30.0191 4 29.0647 4Z",
    fill: "#BEDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.d1c0708e7796be5b9ce3238d684c3be8.svg";
export { ForwardRef as ReactComponent };